import React, { Component } from 'react'
import { Form, DatePicker, Input, Button, Popconfirm, message } from 'antd'
import moment from 'moment'
import { validateDate } from '../util'

const FormItem = Form.Item
const propTypes = {}

class ScheduleDrawingDatesView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditing: false,
      currentDates: {}
    }
  }

  componentDidMount() {
    this.setState({
      currentDates: this.props.data
    })
  }

  componentWillUnmount() {
    this.props.clearHighlight()
  }

  handleSaveDatesClick = () => {
    const form = this.props.form

    form.validateFields((err, values) => {
      if (err) {
        return
      }

      let transformedDates = {}
      let scheduleType = null
      let scheduleDescription = null
      const currentDates = this.state.currentDates
      Object.keys(values).forEach(function(key, value) {
        if (values[key] !== null) {
          if (moment.isMoment(values[key])) {
            if (!moment(values[key]).isSame(currentDates[key])) {
              scheduleType = key
              scheduleDescription = values['notes']
            }
          }
        }
        transformedDates[key] = validateDate(values[key])
      })
      this.props.updateDrawingDates({
        jobId: this.props.jobId,
        scheduleId: this.props.machineIndex,
        userId: this.props.userId,
        content: transformedDates,
        scheduleType: scheduleType,
        description: scheduleDescription
      })

      form.resetFields()
      this.props.clearFields()
    })
    this.setState({
      isEditing: false
    })
  }

  handleNotesBlur = e => {
    this.props.updateNotes({
      jobId: this.props.jobId,
      scheduleId: this.props.machineIndex,
      userId: this.props.userId,
      notes: e.target.value
    })
    message.success('Notes saved.')
  }

  handleCancelEditClick = () => {
    this.props.clearFields()
  }

  cancelDelete = () => {
    this.props.clearFields()
  }

  confirmDelete = () => {
    this.props.deleteSchedule(this.props.machineIndex)
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { data, isEditing } = this.props
    return (
      <div>
        <Form layout="vertical">
          <div className="row sceduleTitleRow">
            <div className="col-md-9">
              {!isEditing && <h2>{data.name}</h2>}
              {isEditing && (
                <div>
                  <FormItem>
                    {getFieldDecorator('name', {
                      rules: [
                        {
                          required: true,
                          message: 'Schedule device must have a name.'
                        }
                      ],
                      initialValue: data.name
                    })(<Input />)}
                  </FormItem>
                </div>
              )}
            </div>
            <div className="col-md-3">
              {isEditing && (
                <div className="datesButtonArea">
                  <Button type="primary" icon="save" onClick={() => this.handleSaveDatesClick()} />
                  <Button
                    type="default"
                    icon="close"
                    className="marginRight10"
                    onClick={() => this.handleCancelEditClick()}
                  />
                </div>
              )}
            </div>
          </div>
          {data && (
            <div>
              {/* LINE 1 */}
              <div className="row padding10-all">
                <div className="col-4">
                  <div className="jobDetailsHeader">Requested Preliminary Layout Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('requested_preliminary_layout_drawings_date', {
                        initialValue: moment(
                          data.requested_preliminary_layout_drawings_date
                        ).isValid()
                          ? moment(data.requested_preliminary_layout_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.requested_preliminary_layout_drawings_date !== null
                        ? moment(data.requested_preliminary_layout_drawings_date).format(
                            'MM/D/YYYY'
                          )
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">Received Preliminary Layout Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('received_preliminary_layout_drawings_date', {
                        initialValue: moment(
                          data.received_preliminary_layout_drawings_date
                        ).isValid()
                          ? moment(data.received_preliminary_layout_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.received_preliminary_layout_drawings_date !== null
                        ? moment(data.received_preliminary_layout_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">Sent Preliminary Layout Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('sent_preliminary_layout_drawings_date', {
                        initialValue: moment(data.sent_preliminary_layout_drawings_date).isValid()
                          ? moment(data.sent_preliminary_layout_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.sent_preliminary_layout_drawings_date !== null
                        ? moment(data.sent_preliminary_layout_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
              </div>
              {/* LINE 2 */}
              <div className="row padding10-all">
                <div className="col-4">
                  <div className="jobDetailsHeader">Requested Final Layout Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('requested_final_layout_drawings_date', {
                        initialValue: moment(data.requested_final_layout_drawings_date).isValid()
                          ? moment(data.requested_final_layout_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.requested_final_layout_drawings_date !== null
                        ? moment(data.requested_final_layout_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">Received Final Layout Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('received_final_layout_drawings_date', {
                        initialValue: moment(data.received_final_layout_drawings_date).isValid()
                          ? moment(data.received_final_layout_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.received_final_layout_drawings_date !== null
                        ? moment(data.received_final_layout_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">Sent Final Layout Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('sent_final_layout_drawings_date', {
                        initialValue: moment(data.sent_final_layout_drawings_date).isValid()
                          ? moment(data.sent_final_layout_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.sent_final_layout_drawings_date !== null
                        ? moment(data.sent_final_layout_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
              </div>
              {/* LINE 3 */}
              <div className="row padding10-all">
                <div className="col-4">
                  <div className="jobDetailsHeader">Final Approved Layout Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('final_approved_layout_drawings_date', {
                        initialValue: moment(data.final_approved_layout_drawings_date).isValid()
                          ? moment(data.final_approved_layout_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.final_approved_layout_drawings_date !== null
                        ? moment(data.final_approved_layout_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4" />
                <div className="col-4" />
              </div>
              {/* LINE 4 */}
              <div className="row padding10-all">
                <div className="col-4">
                  <div className="jobDetailsHeader">Requested Preliminary Design Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('requested_preliminary_design_drawings_date', {
                        initialValue: moment(
                          data.requested_preliminary_design_drawings_date
                        ).isValid()
                          ? moment(data.requested_preliminary_design_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.requested_preliminary_design_drawings_date !== null
                        ? moment(data.requested_preliminary_design_drawings_date).format(
                            'MM/D/YYYY'
                          )
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">Received Preliminary Design Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('received_preliminary_design_drawings_date', {
                        initialValue: moment(
                          data.received_preliminary_design_drawings_date
                        ).isValid()
                          ? moment(data.received_preliminary_design_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.received_preliminary_design_drawings_date !== null
                        ? moment(data.received_preliminary_design_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">Sent Preliminary Design Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('sent_preliminary_design_drawings_date', {
                        initialValue: moment(data.sent_preliminary_design_drawings_date).isValid()
                          ? moment(data.sent_preliminary_design_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.sent_preliminary_design_drawings_date !== null
                        ? moment(data.sent_preliminary_design_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
              </div>
              {/* LINE 5 */}
              <div className="row padding10-all">
                <div className="col-4">
                  <div className="jobDetailsHeader">Requested Final Design Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('requested_final_design_drawings_date', {
                        initialValue: moment(data.requested_final_design_drawings_date).isValid()
                          ? moment(data.requested_final_design_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.requested_final_design_drawings_date !== null
                        ? moment(data.requested_final_design_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">Received Final Design Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('received_final_design_drawings_date', {
                        initialValue: moment(data.received_final_design_drawings_date).isValid()
                          ? moment(data.received_final_design_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.received_final_design_drawings_date !== null
                        ? moment(data.received_final_design_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">Sent Final Design Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('sent_final_design_drawings_date', {
                        initialValue: moment(data.sent_final_design_drawings_date).isValid()
                          ? moment(data.sent_final_design_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.sent_final_design_drawings_date !== null
                        ? moment(data.sent_final_design_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
              </div>
              {/* LINE 6 */}
              <div className="row padding10-all">
                <div className="col-4">
                  <div className="jobDetailsHeader">Final Approved Design Drawings</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('final_approved_design_drawings_date', {
                        initialValue: moment(data.final_approved_design_drawings_date).isValid()
                          ? moment(data.final_approved_design_drawings_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.final_approved_design_drawings_date !== null
                        ? moment(data.final_approved_design_drawings_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4" />
                <div className="col-4" />
              </div>
              <div className="row">
                <div className="col-md-12 text-right">
                  <Popconfirm
                    title="Are you sure you want to delete this schedule?"
                    onConfirm={this.confirmDelete}
                    onCancel={this.cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button className="marginRight20" type="danger" icon="delete" />
                  </Popconfirm>
                </div>
              </div>
            </div>
          )}
        </Form>
      </div>
    )
  }
}

ScheduleDrawingDatesView.propTypes = propTypes
export default Form.create()(ScheduleDrawingDatesView)



// WEBPACK FOOTER //
// ./src/components/ScheduleDrawingDatesView.js